import { DELETE_INFO_APPLY_START } from '../../types';

export const delete_info_apply = (payload) => ({
  type: DELETE_INFO_APPLY_START,
  payload,
});
